import {OdontoDistrictsFilter} from 'domain/usecases/private/guide-flow/dental-guide/post-providers';

const MAX_DISTRICTS = 100;

const formattedDistrictNames = (
	districtNames: string,
	ufCode: string,
	cityName: string,
	isGeoFlow: boolean,
): OdontoDistrictsFilter[] => {
	if (isGeoFlow && !districtNames) return [];

	if (!districtNames || (!isGeoFlow && districtNames.split(',').length > MAX_DISTRICTS)) {
		return [{uf: ufCode, cidade: cityName, bairro: ''}];
	}

	const separator = isGeoFlow ? '-' : ',';
	const districtList = districtNames
		.split(separator)
		.map(item => item.trim())
		.filter(Boolean);

	if (isGeoFlow && districtList.length >= 3) {
		const [bairro, cidade, uf] = districtList;
		return [{uf, cidade, bairro}];
	}

	return districtList.map(bairro => ({
		uf: ufCode,
		cidade: cityName,
		bairro,
	}));
};

export {formattedDistrictNames};
